import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "relative flex flex-col h-full" }
const _hoisted_2 = {
  class: "flex-grow overflow-y-auto mb-4",
  ref: "conversationContainer"
}
const _hoisted_3 = { class: "flex items-start mb-2" }
const _hoisted_4 = { class: "bg-gunmetal text-white p-4 rounded-tr-lg rounded-br-lg rounded-bl-lg max-w-xl" }
const _hoisted_5 = { class: "flex items-end justify-end" }
const _hoisted_6 = { class: "bg-khaki text-black p-4 rounded-tl-lg rounded-tr-lg rounded-bl-lg max-w-xl" }
const _hoisted_7 = {
  key: 0,
  class: "flex items-start mb-2"
}
const _hoisted_8 = { class: "relative bg-gunmetal text-white p-7 rounded-tr-lg rounded-br-lg rounded-bl-lg max-w-xl" }
const _hoisted_9 = { class: "sticky bottom-0 bg-almond pt-2" }
const _hoisted_10 = { class: "relative" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "flex justify-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conversation, (qa, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "mb-6"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(qa.question), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(qa.answer), 1)
          ])
        ]))
      }), 128)),
      (_ctx.currentQuestion)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createTextVNode(_toDisplayString(_ctx.currentQuestion) + " ", 1),
              (!_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('getAlternativeQuestion'))),
                    class: "absolute bottom-0 -right-0 bg-almond p-1",
                    style: {"border-top-left-radius":"25%","border-bottom-right-radius":"25%"}
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['far', 'circle-xmark'],
                      class: "text-gray-800"
                    })
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ], 512),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _withDirectives(_createElementVNode("textarea", {
          ref: "answerInput",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.answerInput) = $event)),
          onKeydown: [
            _cache[2] || (_cache[2] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.handleKeyDown && _ctx.handleKeyDown(...args)), ["exact"]), ["enter"])),
            _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => {}, ["shift","stop"]), ["enter"]))
          ],
          placeholder: _ctx.getPlaceholder,
          class: "w-full mb-2 p-4 border rounded-lg focus:outline-none focus:ring text-black",
          rows: "3"
        }, null, 40, _hoisted_11), [
          [_vModelText, _ctx.answerInput]
        ]),
        (_ctx.voiceMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleVoiceInput && _ctx.toggleVoiceInput(...args))),
              class: _normalizeClass(["absolute bottom-4 right-4 p-2 rounded-full hover:bg-gray-100 transition-colors", { 'text-red-500': _ctx.isRecording }])
            }, [
              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'microphone'] })
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", {
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
          class: "px-4 py-2 bg-khaki text-black rounded hover:bg-walnutBrown hover:text-white"
        }, " Submit Answer "),
        _createElementVNode("button", {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('finishInterview'))),
          class: "px-4 py-2 bg-gunmetal text-white rounded hover:bg-black"
        }, " I'm done. Write it Up! ")
      ])
    ])
  ]))
}